import { useParams } from 'react-router-dom';
import { GeneralLedgerSidepanel, Account } from '@ui/src';
import { useAppSelector } from '@store';
import { OrganizationType } from '../types';
import useTransactionFromFee from './hooks/use-transaction-from-fee';

const TransactionFromFeeHOC = ({ type }: { type: OrganizationType }) => {
  const { customerId, feeId } = useParams();

  const { currencies: dictionariesCurrenciesList, currenciesList: currencies } =
    useAppSelector((state) => state.root);
  const {
    creditAccountBalance,
    debitAccountBalance,
    accountCategories,
    debitBalances,
    creditBalances,
  } = useAppSelector((state) => state.customerTransactionFromFee);
  const { baseCurrency } = useAppSelector(
    (state) => state.customersDictionaries,
  );
  const {
    baseInformation: individualBaseInformation,
    baseInformationIsLoading: individualBaseInformationIsLoading,
  } = useAppSelector((state) => state.individualCustomers.info.general);
  const {
    baseInformation: corporateBaseInformation,
    baseInformationIsLoading: corporateBaseInformationIsLoading,
  } = useAppSelector((state) => state.corporateCustomers.info.general);

  const info =
    type === OrganizationType.INDIVIDUAL
      ? individualBaseInformation
      : corporateBaseInformation;
  const debitAccounts: Account[] = info?.accounts || [];
  const debitAccountsIsLoading =
    type === OrganizationType.INDIVIDUAL
      ? individualBaseInformationIsLoading
      : corporateBaseInformationIsLoading;

  const {
    panelIsOpen,
    handleClose,
    createIsLoading,
    control,
    onSubmit,
    availableCurrencies,
    debitAccountsList,
    creditAccounts,
    creditAccountsListLoading,
    creditAccountsListUpdateInProgress,
    debitBalanceIsLoading,
    debitBalanceIsFetching,
    creditBalanceIsLoading,
    creditBalanceIsFetching,
    onUpdateBalance,
    allDebitAccountBalancesIsLoading,
    allDebitAccountBalancesisFetching,
    allCreditAccountBalancesIsLoading,
    allCreditAccountBalancesisFetching,
    onSearch,
    errors,
    accountsCategoriesLoading,
    setCreditAccounts,
    getCreditAccountsListAction,
    currencyId,
    globalError,
  } = useTransactionFromFee({
    type,
    customerId,
    debitAccounts,
    baseCurrency,
    debitBalances,
    creditBalances,
    currencies,
    info,
    feeId,
  });

  return (
    <GeneralLedgerSidepanel
      panelIsOpen={panelIsOpen}
      handleClose={handleClose}
      title="Write-off funds"
      okButtonText="Write-off"
      createIsLoading={createIsLoading}
      isLoading={debitAccountsIsLoading as boolean}
      control={control}
      onSubmit={onSubmit}
      currencies={availableCurrencies}
      currenciesList={dictionariesCurrenciesList}
      debitAccounts={debitAccountsList}
      creditAccounts={creditAccounts}
      creditIsLoading={
        creditAccountsListLoading || creditAccountsListUpdateInProgress
      }
      debitBalanceIsLoading={debitBalanceIsLoading || debitBalanceIsFetching}
      creditBalanceIsLoading={creditBalanceIsLoading || creditBalanceIsFetching}
      onUpdateBalance={onUpdateBalance}
      debitAccountBalance={debitAccountBalance}
      creditAccountBalance={creditAccountBalance}
      debitBalances={debitBalances}
      creditBalances={creditBalances}
      allDebitAccountIsLoading={
        allDebitAccountBalancesIsLoading || allDebitAccountBalancesisFetching
      }
      allCreditAccountIsLoading={
        allCreditAccountBalancesIsLoading || allCreditAccountBalancesisFetching
      }
      onSearchAutocomplete={onSearch}
      errors={errors && Object.keys(errors).length ? errors : undefined}
      accountCategories={accountCategories}
      accountsCategoriesLoading={accountsCategoriesLoading}
      setCreditAccounts={setCreditAccounts}
      setCreditAccountQuery={getCreditAccountsListAction}
      currencyId={currencyId}
      errorSidepanel={globalError}
      sidepanelExpandedKey="customers-gl-fee"
      isEditable
    />
  );
};

export default TransactionFromFeeHOC;
